export default {
  navigationBarTitleText: '预约成功'
};
